module.exports = __webpack_public_path__ + "img/SKMP_map.feaa7673.png";